import { memo, type HTMLAttributes, type ReactNode } from 'react';

/**
 * Spec1-P10 §10.2 five-slot mobile card anatomy (immutable order):
 * Primární → Status → Klíčové → Sekundární → Akce
 */
export type MobileCardSlotName =
  | 'primary'
  | 'status'
  | 'key'
  | 'secondary'
  | 'actions';

export interface MobileCardSlotProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  readonly slot: MobileCardSlotName;
  readonly children: ReactNode;
}

export const MobileCardSlot = memo<MobileCardSlotProps>(({
  slot,
  children,
  className,
  ...rest
}) => (
  <div data-mobile-card-slot={slot} className={className} {...rest}>
    {children}
  </div>
));

MobileCardSlot.displayName = 'MobileCardSlot';
